/**
 * Pricing page scripts
 *
 * @copyright 2018 Linguistica 360
 */

import { moneyFormat, resolveRoot } from '../shared/utils.js';
import { Script, injector } from '../shared/injector.js';

import $ from 'jquery';
import { ImageTextFitter } from '../shared/image-text-fitter.js';

import iziToast from 'izitoast';

import { LANGUAGE } from '../shared/config.js';

const language = LANGUAGE.toLowerCase();
const Language = LANGUAGE;

const WIDTH = 506;
const HEIGHT = 701;
const FOOTER = 'Enter this code [coupon code] at the bottom of the signup ' +
               'page for your *{}* subscription.\n' +
               `*News in Slow ${Language}*     www.newsinslow${language}.com`;

import json from '../../resources/giftcard.generated.json';


injector.injectClass(class extends Script {
    onLoad() {
        this.images = {};
        this.text = '[Live Text Preview]';
        this.center = $('.gift-card-center').is(':checked');

        this.$wrapper = $('.gift-card-creator');
        this.canvas = $('#gift_card_creator').get(0);

        this.initGcc();

        $('.gift-card-input').on('input', () => {
            this.text = $('.gift-card-input').val();
            this._draw();
        });

        $('.gift-card-center').on('click', () => {
            this.center = $('.gift-card-center').is(':checked');
            this._draw();
        });

        const $form = $('#gcc_form');
        $('#gift_card_preview').on('click', () => {
            // submit the form to _blank preview
            const action = $form.attr('action');
            $form.attr('target', '_blank');
            $form.attr('action', resolveRoot('gift-card-preview'));
            $form.trigger('submit');

            setTimeout(() => {
                // restore
                $form.removeAttr('target');
                $form.attr('action', action);
            }, 250);
        });

        $form.on('submit', () => {
            if (!this.checkRecaptcha()) {
                iziToast.error({ title: 'Please validate reCAPTCHA!' });
                return false;
            }
        });

        this._resize();
    }

    checkRecaptcha() {
        // Ignore for local development, where captcha is removed from the form
        if (!$('#ns-recaptcha').length) return true;

        const res = $('#g-recaptcha-response').val();
        return !(res == '' || res == undefined || res.length == 0);
    }

    initGcc() {
        const gcc = JSON.parse($('#gcc_json').val().replace(/'/g, '"'));
        const discounts = JSON.parse($('#gcc_discounts').val().replace(/'/g, '"'));

        for (let category in gcc) {
            const $option = $('<option>');
            $option.val(category);
            $option.html(gcc[category].title);
            $('#gcc_package').append($option);
        }

        // Hide product selection if there is only one product
        if (gcc.everything) {
            $('#gcc_package').hide();
        } else {
            $('#gcc_package').show();
        }

        $('#template').val('default');

        $('#gcc_duration,#gcc_package').on('change keyup paste', () => {
            if ($('#gcc_duration').val() < 0) {
                $('#gcc_duration').val(1);
            }

            const option = $('#gcc_package').val();
            const product = gcc[option].products[0];

            const m = $('#gcc_duration').val();
            let price = product.price * m;

            let discount = discounts[m];
            if (m > 1 && !discount) discount = discounts.max;
            if (discount) {
                price = price - Math.floor(price * discount) / 100;

                $('#discount').html(`(${discount}% off)`);
            } else {
                $('#discount').html('');
            }

            $('#price').html('$' + moneyFormat(price));

            $('#template').val(product.template);
            $('#product').val(product.id + '-' + product.plan);

            this._draw();
        }).trigger('change');
    }

    onResize() {
        this._resize();
    }

    _resize() {
        const width = this.$wrapper.width();
        const height = Math.floor(width / WIDTH * HEIGHT);

        $(this.canvas).width(width).height(height);
    }

    _draw() {
        const ctx = this.canvas.getContext('2d');

        ctx.fillStyle = 'rgb(230, 230, 230)';
        ctx.fillRect(0, 0, WIDTH, HEIGHT);

        const image = this._getBackground();
        if (!image) {
            this._drawLoading(ctx);
            setTimeout(() => this._draw(), 750); // redraw in 0.75s
            return;
        }

        ctx.drawImage(image, 0, 0, WIDTH, HEIGHT);

        const template = $('#template').val();

        // message
        const mX = json[template].message.left * WIDTH;
        const mY = json[template].message.top * HEIGHT;

        const mW = json[template].message.width * WIDTH;
        const mH = json[template].message.height * HEIGHT;

        const mC = json[template].message.color;

        this._drawText(ctx, mX, mY, mW, mH, mC, this.text, this.center);

        // footer
        const period = $('#gcc_duration').val();

        const subscription = `${period} month`;
        const footer = FOOTER.replace('{}', subscription);

        const fX = json[template].footer.left * WIDTH;
        const fY = json[template].footer.top * HEIGHT;

        const fW = json[template].footer.width * WIDTH;
        const fH = json[template].footer.height * HEIGHT;

        const fC = json[template].footer.color;

        this._drawText(ctx, fX, fY, fW, fH, fC, footer, false);
    }

    _drawText(ctx, x, y, w, h, c, text, center) {
        ctx.fillStyle = `#${c}`;

        const fitter = new ImageTextFitter(ctx, w, h);
        const fit = fitter.fitText(text);
        if (!fit) return;

        fit.segments.forEach((segment) => {
            const font = segment.bold ? fitter.bFont : fitter.nFont;

            let oX = x + segment.x;
            const oY = y + segment.y;

            if (center) oX += (w - segment.linewidth) / 2;

            ctx.font = font.replace('{}', fit.size);
            ctx.fillText(segment.text, oX, oY);
        });
    }

    _getBackground() {
        const image = $('#template').val();

        if (!Object.prototype.hasOwnProperty.call(this.images, image)) {
            this.images[image] = null;

            const node = new Image();

            node.onload = () => {
                this.images[image] = node;
                this._draw();
            };

            const name = `gift-card-template.${image}.png`;
            node.src = resolveRoot(`images/gift-cards/${name}`);
        }

        return this.images[image];
    }

    _drawLoading(ctx) {
        const dots = Math.floor(new Date().getTime() / 1000) % 4;
        const text = 'Loading Background';

        const size = 27;
        ctx.font = `${size}px Arial`;

        const width = ctx.measureText(text).width;

        const left = (WIDTH - width) / 2;
        const right = left + width;

        ctx.fillStyle = '#c3272f';
        ctx.fillText(text, left, (HEIGHT + size) / 2);

        const dsize = size / 6;
        const hheight = HEIGHT / 2;

        ctx.lineWidth = 2;
        ctx.strokeStyle = '#c3272f';
        for (let i = 0; i < dots; ++i) {
            const p = (size / 3 * 2) * (i + 1);

            ctx.beginPath();
            ctx.arc(left - p, hheight + dsize, dsize, 0, 2 * Math.PI);
            ctx.stroke();

            ctx.beginPath();
            ctx.arc(right + p, hheight + dsize, dsize, 0, 2 * Math.PI);
            ctx.stroke();
        }
    }
}, ['gift-card-creator']);
